import { Portal } from "@radix-ui/react-popover";
import { Dialog as DialogComponent } from "./Dialog";
import { DialogRoot } from "./Root";
import { DialogTrigger } from "./Trigger";
import { DialogContent } from "./Content";
import { DialogTitle } from "./Title.styles";
import { DialogDescription } from "./Description.styles";

export type { DialogProps } from "./Dialog";
export type { DialogContextType } from "./dialog.context";

export const Dialog = {
  Root: DialogRoot,
  Trigger: DialogTrigger,
  Content: DialogContent,
  Title: DialogTitle,
  Description: DialogDescription,
  Portal,
  // The main component as a property
  Dialog: DialogComponent
};
